module.exports = __webpack_public_path__ + "img/Group 1000005904.7ad271e6.png";